const initialState = {
  brokerBanners: null,
  brokerBanner: null,
};

const brokerBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_BROKER_BANNERS":
      return {
        ...state,
        brokerBanners: action.data,
      };
    case "GET_BROKER_BANNER_BY_ID":
      return {
        ...state,
        brokerBanner: action.data,
      };
    case "ADD_BROKER_BANNER":
    case "UPDATE_BROKER_BANNER_BY_ID":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default brokerBannerReducer;
